import React, { useEffect, Suspense, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { connect } from 'react-redux';

import LockScreen from './global/LockScreen';
import Home from './screens/Home';
import RequireAdmin from './auth/RequireAdmin';
import Error from './components/Error';
import { fetchContext } from './redux/actions/contextActions';
import { fetchSettings } from './redux/actions/settingsActions';

// Code-split: the Admin portal (and its Chart.js dependency) has no reason
// to ship in the bundle every clinician/client loads on every visit - only
// fetch it once someone actually reaches /admin.
const Admin = lazy(() => import('./screens/Admin/Admin'));

const AdminLoader = () => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', width: '100vw' }}>
    <img className="logo-loader logo-loader--pulse" src="/logo2.svg" alt="Loading" />
  </div>
);

const AppRoutes = (props) => {
  const { fetchSettings, fetchContext, transitionLockScreen } = props;

  useEffect(() => {
    fetchSettings(() => {
      fetchContext();
    });
  }, []);

  return (
    <>
      <Routes>
        <Route path="/maintenance" element={<Error />} />
        <Route path="/home/*" element={<Home />} />
        <Route path="/admin/*" element={<RequireAdmin><Suspense fallback={<AdminLoader />}><Admin /></Suspense></RequireAdmin>} />
        <Route path="/" element={<Navigate to="/home" replace />} />
      </Routes>

      {transitionLockScreen && <LockScreen />}
    </>
  );
};

export default connect(
  (state) => ({
    context: state.context,
    transition: state.transition,
    transitionLockScreen: state.transitionLockScreen,
    clientId: state.clientId,
  }),
  { fetchSettings, fetchContext }
)(AppRoutes);
